import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserTie,
  faUser,
  faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import style from './index.scss';
import { Col, Row } from 'antd';
import { toLower } from 'lodash';

export default function GraphPanel({
  alertDetails: { data },
  typlogyActions,
  handleGraphClick
}) {
  let details = {};

  const preventionAlertColors = useCallback(
    (key) => {
      return typlogyActions?.find(
        ({ displayName }) => toLower(displayName) === toLower(key)
      )?.alertLevelColor;
    },
    [typlogyActions]
  );

  try {
    if (
      data?.triggeredRulesEntitySummary &&
      typeof data.triggeredRulesEntitySummary === 'string'
    ) {
      details = JSON.parse(data.triggeredRulesEntitySummary);
    } else {
      console.warn('triggeredRulesEntitySummary is missing or not a string');
    }
  } catch (error) {
    console.log('JSON parse in graph', error);
  }

  return (
    <div className={style.container}>
      <Row className={style.topSection}>
        <Col
          span={2}
          className={style.userIconWrapper}
          onClick={() => handleGraphClick()}>
          <div>
            <FontAwesomeIcon icon={faUser} className={style.userIcon} />
            <div className={style.title}>Sender</div>
          </div>
          {Object.keys(details).map((item) => {
            const key = item.toLowerCase();
            return (
              key === 'sender' && (
                <div
                  className={style.tagWrapper}
                  key={key}
                  style={{
                    top:
                      Object.keys(details[key]).length > 1 ? '-42px' : '-11px'
                  }}>
                  {Object.keys(details[key]).map((tag) => (
                    <div
                      style={{
                        color: preventionAlertColors(tag),
                        boxShadow: `0px 0px 8px 2px ${preventionAlertColors(
                          tag
                        )}ba`
                      }}
                      className={style.tag}
                      key={`sender-${tag}`}>
                      <span>{tag}</span>
                      <span className={style.count}>{details[key][tag]}</span>
                    </div>
                  ))}
                </div>
              )
            );
          })}
        </Col>
        <Col span={18}>
          <div className={style.arrowIconGroup}>
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </Col>
        <Col
          span={4}
          className={style.userIconWrapper}
          onClick={() => handleGraphClick()}>
          <div>
            <FontAwesomeIcon icon={faUserTie} className={style.userIcon} />
            <div className={style.title}>Beneficiary</div>
          </div>
          {Object.keys(details).map((item) => {
            const key = item.toLowerCase();
            return (
              key === 'receiver' && (
                <div
                  className={style.tagWrapper}
                  key={key}
                  style={{
                    top:
                      Object.keys(details[key]).length > 1 ? '-42px' : '-11px',
                    right: 0
                  }}>
                  {Object.keys(details[key]).map((tag) => (
                    <div
                      style={{
                        color: preventionAlertColors(tag),
                        boxShadow: `0px 0px 8px 2px ${preventionAlertColors(
                          tag
                        )}ba`
                      }}
                      className={style.tag}
                      key={`sender-${tag}`}>
                      <span>{tag}</span>
                      <span className={style.count}>{details[key][tag]}</span>
                    </div>
                  ))}
                </div>
              )
            );
          })}
        </Col>
      </Row>
      <div className={style.bottomSection}>
        {Object.keys(details)
          .filter((key) =>
            ['sending_partner', 'receiving_partner'].includes(key.toLowerCase())
          )
          .map((partner) => (
            <div
              className={style.partnerWrapper}
              key={`partner-${partner}`}
              onClick={() => handleGraphClick()}>
              <span className={style.dot} />
              <span
                className={style.title}
                style={{
                  paddingTop: Object.keys(details[partner])?.length === 1 && 10
                }}>
                Partner
              </span>
              <div className={style.tagWrapper}>
                {Object.keys(details[partner]).map((key) => (
                  <div className={style.tag} key={`partner-tag-${key}`}>
                    <span>{key}</span>
                    <span className={style.count}>{details[partner][key]}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
